exports.tagline = `A scratchpad for exploring favorite themes: Borges, time, consciousness, computer science, etc.`;



// WEBPACK FOOTER //
// ./src/config/constants.js